import {StyleSheet} from 'react-native';
import Typography from '../../../../../constants/Typography';
import {createModalBaseStyles} from '../../../../../styles/modalBaseStyles.shared';

/**
 * @param isZoomed extreme browser zoom (320x256 CSS px at 400%): the fixed-size
 *   dialog fills the viewport width, is top-aligned (a centred, scrolling box
 *   spills past the top where it cannot be scrolled to) and scrolls as a whole.
 *   Never true on native, real phones or normal desktop widths.
 */
export const createIndirectActivityModalStyles = (
  theme: any,
  isZoomed: boolean = false,
) =>
  StyleSheet.create({
    ...(createModalBaseStyles(theme) as any),

    // IndirectActivityModal-specific styles
    container: {
      flex: 1,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: theme.indirectActivityModalOverlay,
      ...(isZoomed && {
        padding: Typography.padding.padding8,
        justifyContent: 'flex-start',
      }),
    },
    modal: {
      backgroundColor: theme.notedModalBG,
      paddingVertical: Typography.padding.padding24,
      borderColor: theme.notesModalBorder,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderRadius: Typography.radius.radius12,
      gap: Typography.gap.gap24,
      justifyContent: Typography.textAlign.centerAlign,
      maxHeight: Typography.height.height544,
      width: Typography.width.width896,
      ...(isZoomed && {
        width: '100%',
        maxWidth: '100%',
        height: 'auto',
        maxHeight: 'calc(100vh - 16px)',
        overflowY: 'auto',
        justifyContent: 'flex-start',
        paddingVertical: Typography.padding.padding12,
        gap: Typography.gap.gap12,
      } as object),
    },
    separatorLine: {
      height: Typography.height.height1,
      backgroundColor: theme.noteHeaderSeparator,
    },
    content: {
      flexDirection: 'column',
      paddingHorizontal: isZoomed
        ? Typography.padding.padding12
        : Typography.padding.padding24,
      //gap: Typography.gap.gap36,
      //height: Typography.height.height384,
    },
    applyToContainer: {
      gap: Typography.gap.gap8,
    },
    listContainer: {justifyContent: Typography.contentAlign.spaceBetween},
    label: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      color: theme.notesModalTitle,
    },
    subLabel: {
      fontSize: Typography.fontSize.fontSize24,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.woStatusDesc,
    },
    noteLog: {
      flexDirection: 'column',
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.noteSectionBorder,
      borderRadius: Typography.radius.radius8,
      paddingVertical: Typography.padding.padding12,
      flex: 1,
      maxWidth: isZoomed ? '100%' : Typography.width.width400,
      ...(isZoomed && {marginBottom: Typography.gap.gap12}),
    },
    footerButtons: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.flexEnd,
      // gap: Typography.gap.gap16,
      paddingHorizontal: isZoomed
        ? Typography.padding.padding12
        : Typography.padding.padding24,
      ...(isZoomed && {flexWrap: 'wrap'}),
    },
  });